import React, { Component } from "react";
import { Container, Card, Row, Col, Form, Button, Image, Alert } from "react-bootstrap";
import logo from '../../media/logo.png'
import { connect } from 'react-redux';
import { trySignIn} from '../../actions/generic/authActions';
import _ from 'lodash';

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: ''
        };
      } 

    loginError = () => {

        if (!_.isEmpty(this.props.auth.authError)){
            return (
              <Alert variant='danger'>
                {this.props.auth.authError}
              </Alert>
            );
        }
    }

    //This is temporary...it uses custom CSS styling which isn't great...and doesn't use proper React-bootstrap components
    loginForm2 = () => {
        return (
            <div>
                <div className="sidenav bg-light">
                <div className="login-main-text text-center">
                <Image height='90' src={logo}/>
                    <h2></h2>
                </div>
                </div>
                <div className="main">
                <div className="col-md-6 col-sm-12">
                    <div className="login-form">
                    {this.loginError()}
                        <Form action="" className="justify-content-center" >
                            <Form.Group>
                                <Form.Label className="sr-only">Username</Form.Label>
                                <Form.Control value={this.state.username} onChange={(e) => this.setState({username: e.target.value})} type="text" placeholder="Username"/>
                            </Form.Group>
                            <Form.Group>
                            <Form.Label className="sr-only">Password</Form.Label>
                                <Form.Control value={this.state.password} type="password" onChange={(e) => this.setState({password: e.target.value})} placeholder="Password"/>
                            </Form.Group>
                            <Button type="button" className="btn btn-primary btn-lg" onClick={this.onSignInClick}>Login</Button>
                        </Form>
                    </div>
                </div>
                </div>
            </div>
        );
    }


    loginForm = () => {
        return (
            <Container fluid className="min-vh-100">
                <Row fluid className="min-vh-100 align-middle">
                    <Col className=" min-vh-100 text-center form p-4 h-100 w-100 bg-secondary">
                        <Card xl={5} lg={6} md={8} sm={10} className="py-2" className="bg-success position-absolute top-50 start-50 translate-middle">
                            <h1 class="py-2 text-truncate">Login</h1>
                            <div class="px-2">
                                <Form action="" class="justify-content-center" onSubmit={this.onSignInClick}>
                                    <Form.Group>
                                        <Form.Label class="sr-only">Username</Form.Label>
                                        <Form.Control type="text" placeholder="Username"/>
                                    </Form.Group>
                                    <Form.Group>
                                    <Form.Label class="sr-only">Password</Form.Label>
                                        <Form.Control type="text" placeholder="Password"/>
                                    </Form.Group>
                                    <Button type="submit" class="btn btn-primary btn-lg">Login</Button>
                                </Form>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }

    onSignInClick = () => {
        this.props.trySignIn(this.state.username, this.state.password);
    }

    render() {
        return (
            this.loginForm2()
        );
    }

}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

export default connect(
    // map state to props
    mapStateToProps, 
    // map dispatch to props
    (dispatch, ownProps) => ({
        trySignIn: (username, password) => dispatch(trySignIn(username, password)),
      })
    )(Login);